import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { QuizService } from '../services/quiz.service';
import { QuizItem } from '../interfaces/quiz.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quiz-view',
  templateUrl: './quiz-view.component.html',
  styleUrls: ['./quiz-view.component.css'],
})
export class QuizViewComponent implements OnInit {
  quiz: QuizItem | null = null;
  showLoader = false;
  env = environment;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private loaderService: LoaderService,
    private quizService: QuizService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loadQuiz(id);
    }
  }

  loadQuiz(id: string | number): void {
    this.showLoader = true;
    this.quizService
      .getQuizById(id)
      .then((res) => {
        this.quiz = res.data || res;
        this.showLoader = false;
      })
      .catch((err) => {
        this.snackBar.open('Erro ao carregar os dados do quiz.', null, { duration: 3000 });
        this.showLoader = false;
        this.router.navigate(['/devocional']);
      });
  }

  isExpired(endDate: string | Date): boolean {
    if (!endDate) return false;
    return new Date(endDate) < new Date();
  }

  getAvatarUrl(avatar: string | undefined): string {
    if (avatar) {
      return this.env.endPointApi + 'user/avatar/' + avatar;
    }
    return '';
  }

  getFirstLetter(name: string): string {
    return name ? name.charAt(0).toUpperCase() : '?';
  }

  formatShortName(fullName: string): string {
    if (!fullName) return '';
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0];
    return `${parts[0]} ${parts[parts.length - 1]}`;
  }
}
